/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    disabled: { type: 'variant', values: [ true ] },
    focus: { type: 'variant', values: [ true ] },
    hover: { type: 'variant', values: [ true ] },
    pressed: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { alternative: true },
      tokens: {
        fontSize: 16,
        lineHeight: 1.5,
        paddingBottom: 8,
        paddingTop: 8
      }
    },
    {
      if: { hover: true },
      tokens: { inputBackgroundColor: '#d8dae2' }
    },
    {
      if: { disabled: true },
      tokens: {
        inputBackgroundColor: 'rgba(0, 0, 0, 0)',
        inputBorderColor: '#9c9faa',
        textColor: '#cdcfd5'
      }
    },
    { if: { focus: true }, tokens: { inputBorderWidth: 3 } }
  ],
  tokens: {
    fontSize: 18,
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#394056',
    inputBorderWidth: 1,
    inputWidth: 64,
    lineHeight: 1.55555555,
    padding: 12,
    paddingBottom: 10,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 10,
    textColor: '#394056'
  }
}
export default theme
